document.documentElement.classList.remove('no-js');

/* Replays a lightweight entrance when the browser restores a page from its
   back/forward cache. A BFCache restore does not run DOMContentLoaded again. */
window.addEventListener('pageshow', function (event) {
  var navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var isHistoryReturn = event.persisted || (navigation && navigation.type === 'back_forward');
  if (!isHistoryReturn || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Generic scroll reveals are normally unobserved after their first reveal.
     Reset visible items so their entrance is also replayed on history return. */
  document.querySelectorAll('[data-animate].is-visible').forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
    el.classList.remove('is-visible');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-visible'); });
    });
  });

  document.querySelectorAll('.himp-reveal.is-revealed').forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
    el.classList.remove('is-revealed');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-revealed'); });
    });
  });

  /* CSS keyframe-based text reveals retain their completed state in BFCache.
     Briefly clear their animation so the stagger restarts on history return. */
  var textReveals = document.querySelectorAll(
    '.redesign-hero__slide.is-active .redesign-hero__copy > *, ' +
    '.collection-redesign__hero-copy > h1, ' +
    '.collection-redesign__hero-copy > .rte, ' +
    '.all-brands__hero h1, ' +
    '.all-brands__intro'
  );
  textReveals.forEach(function (el) { el.style.animation = 'none'; });
  if (textReveals.length) void textReveals[0].offsetWidth;
  requestAnimationFrame(function () {
    textReveals.forEach(function (el) { el.style.removeProperty('animation'); });
  });
});

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Global back to top ---------- */
  var backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    backToTop.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  var animated = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && animated.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-delay');
          if (delay) entry.target.style.setProperty('--reveal-delay', delay + 'ms');
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    animated.forEach(function (el) { io.observe(el); });
  } else {
    animated.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Animated counters (trust strip) ---------- */
  var counters = document.querySelectorAll('[data-count-to]');
  if (counters.length) {
    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-count-to'), 10) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var start = 0;
        var duration = 1200;
        var startTime = null;

        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(start + (target - start) * eased);
          el.textContent = value + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        counterIO.unobserve(el);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { counterIO.observe(el); });
  }


  /* ---------- Brand carousel arrows ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;
    var scrollAmount = 220;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount, behavior: 'smooth' }); });
  });

  /* ---------- Collection filter checkboxes ---------- */
  document.querySelectorAll('[data-filter-url]').forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      window.location.href = checkbox.getAttribute('data-filter-url');
    });
  });
});
